import React from "react";
import { Form, Select, Input } from "antd";

const isBooleanOption = [
  {value: true, label: 'True'},
  {value: false, label: 'False'},
]

const breakDurationOption = [
  {value: 5, label: '5'},
  {value: 10, label: '10'},
  {value: 15, label: '15'},
  {value: 20, label: '20'},
  {value: 25, label: '25'},
  {value: 30, label: '30'},
]

const typeOption = [
  {value: 'order_not_pick_up_gt_5', label: 'Order not pick up GT 5'},
  {value: 'order_not_pick_up_gt_10', label: 'Order not pick up GT 10'},
  {value: 'order_not_accepted', label: 'Order not accepted'},
]

const Edit = () => {
  return (<>
    <Form.Item
      name={["notification_title"]}
      label={"Notification Title"}
      rules={[{required: true, message: "Required"}]}
    >
      <Input/>
    </Form.Item>
    <Form.Item
      name={["notification_message"]}
      label={"Notification Message"}
      rules={[{required: true, message: "Required"}]}
    >
      <Input/>
    </Form.Item>
    <Form.Item
      name={["dialogue_title"]}
      label={"Dialogue Title"}
      rules={[{required: true, message: "Required"}]}
    >
      <Input/>
    </Form.Item>
    <Form.Item
      name={["dialogue_message"]}
      label={"Dialogue Message"}
      rules={[{required: true, message: "Required"}]}
    >
      <Input/>
    </Form.Item>
    <Form.Item
      name={["is_active"]}
      label={"Active"}
      rules={[{required: true, message: "Required"}]}
    >
      <Select
        showSearch
        filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={isBooleanOption}
        style={{minWidth: "200px"}}
      />
    </Form.Item>
    <Form.Item
      name={["is_break"]}
      label={"Break"}
      rules={[{required: true, message: "Required"}]}
    >
      <Select
        showSearch
        filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={isBooleanOption}
        style={{minWidth: "200px"}}
      />    </Form.Item>
    <Form.Item
      name={["break_duration"]}
      label={"Break Duration"}
      rules={[{required: true, message: "Required"}]}
    >
      <Select
        showSearch
        filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={breakDurationOption}
      />    </Form.Item>
    <Form.Item
      name={["type"]}
      label={"Type"}
      rules={[{required: true, message: "Required"}]}
    >
      <Select
        showSearch
        filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={typeOption}
      />
    </Form.Item>
  </>);
};
export default Edit;
